import { FormControl, InputAdornment, TextField } from '@mui/material';
import { Box } from '@mui/system';
import * as React from 'react';

export const INPUT_TYPES = {
  TEXT: "text",
  NUMBER: "number",
  PRICE: "price"
}


export default function CustomTextField({
  label,
  value,
  onChange,
  flex = 1,
  required = true,
  readOnly = false,
  inputType = INPUT_TYPES.TEXT
}) {
  const getType = () => {
    if (inputType === INPUT_TYPES.TEXT)
      return 'text';
    else if (inputType === INPUT_TYPES.NUMBER || inputType === INPUT_TYPES.PRICE)
      return 'number';
    else
      return 'text';
  };

  return (
    <Box flex={flex}>
      <FormControl fullWidth sx={{ m: 0, minWidth: 100 }}>
        <TextField
          id="outlined-start-adornment"
          size="small"
          label={label}
          type={getType()}
          variant="outlined"
          value={value}
          multiline
          maxRows={2}
          onChange={onChange}
          required={required}
          readOnly={readOnly}
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={inputType === INPUT_TYPES.PRICE ? {
            startAdornment: <InputAdornment position="start">£</InputAdornment>,
            style: { fontSize: 12 }
          } : { style: { fontSize: 12 } }}
          inputProps={inputType !== INPUT_TYPES.TEXT ? {
            min: "0",
            pattern: "[0-9]*",
            readOnly: readOnly,
          } : {
            readOnly: readOnly,
          }}
        />
      </FormControl>
    </Box>
  );
}
